/**
 * @author      Dario Casertano <dario@casertano.name>
 * @copyright   Copyright (c) 2023 Casertano Dario – All rights reserved.
 * @license     Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International.
 */

import AclStore from "@/vuex/stores/AclStore";
import AppStore from "@/vuex/stores/AppStore";
import CoreStore from "@/vuex/stores/CoreStore";
import VrStore from "@/vuex/stores/VrStore";

import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
    modules: {
        AclStore,
        AppStore,
        CoreStore,
        VrStore,
    },

    strict: (process.env.NODE_ENV !== 'production'),
})
